import React, { useContext } from "react";
import styles from "./index.module.scss";
import { getImagePath } from "../../getImagePath";
import {
	CHARACTERISTICS_OF_RESPONDENTS_AND_HOUSEHOLDS,
	DAILY_DISASTER_PREPARATION,
	LOSSES_FROM_THE_CHISHANG_EARTHQUAKE,
	WHAT_PEOPLE_DID_AFTER_THE_CHISHANG_EARTHQUAKE,
} from "../../constants";
import { ChartDataContext } from "../../hooks/useChartDataQuery";

const buttonList = [
	"所有圖表",
	DAILY_DISASTER_PREPARATION,
	WHAT_PEOPLE_DID_AFTER_THE_CHISHANG_EARTHQUAKE,
	LOSSES_FROM_THE_CHISHANG_EARTHQUAKE,
	CHARACTERISTICS_OF_RESPONDENTS_AND_HOUSEHOLDS,
];

const ChartDataSearchBox = () => {
	const { query, setSearch, toggleThemeFilter } = useContext(ChartDataContext);
	const { search, filter } = query;

	const moveToChartDataDetailSection = () => {
		const detailSection = document.querySelector("#chart-data-detail-section");
		if (detailSection) {
			detailSection.scrollIntoView({ behavior: "smooth" });
		}
	};

	const handleKeyDown = (e) => {
		if (search !== "" && e.key === "Enter") {
			moveToChartDataDetailSection();
		}
	};

	const handleInputChange = (e) => {
		setSearch(e.target.value);
	};

	const isFilterApplied = (filterItem) => {
		if (filterItem === "所有圖表") {
			return filter.size === 4;
		}
		if (filter.size === 4) return false;
		return filter.has(filterItem);
	};

	const handleClickButton = (item) => {
		toggleThemeFilter(item);
		if (!isFilterApplied(item)) {
			moveToChartDataDetailSection();
		}
	};

	return (
		<div className={styles.outerContainer}>
			<div className={styles.container}>
				<span className={styles.title}>
					請選擇想看的調查主題或輸入圖表關鍵字
				</span>
				<div className={styles.buttonGroup}>
					{buttonList.map((item, i) => (
						<button
							key={item}
							className={styles.button}
							onClick={() => handleClickButton(item)}
							type="button"
							aria-pressed={isFilterApplied(item)}
						>
							<span>{item}</span>
							{item !== "所有圖表" && isFilterApplied(item) && (
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="18"
									height="18"
									viewBox="0 0 18 18"
									fill="none"
								>
									<title>清除{item}</title>
									<path
										d="M13.4999 4.49999C13.3592 4.35938 13.1685 4.2804 12.9696 4.2804C12.7707 4.2804 12.58 4.35938 12.4394 4.49999L8.99986 7.93949L5.56036 4.49999C5.41972 4.35938 5.22899 4.2804 5.03011 4.2804C4.83124 4.2804 4.64051 4.35938 4.49986 4.49999C4.35926 4.64063 4.28027 4.83136 4.28027 5.03024C4.28027 5.22911 4.35926 5.41984 4.49986 5.56049L7.93936 8.99999L4.49986 12.4395C4.35926 12.5801 4.28027 12.7709 4.28027 12.9697C4.28027 13.1686 4.35926 13.3593 4.49986 13.5C4.64051 13.6406 4.83124 13.7196 5.03011 13.7196C5.22899 13.7196 5.41972 13.6406 5.56036 13.5L8.99986 10.0605L12.4394 13.5C12.58 13.6406 12.7707 13.7196 12.9696 13.7196C13.1685 13.7196 13.3592 13.6406 13.4999 13.5C13.6405 13.3593 13.7195 13.1686 13.7195 12.9697C13.7195 12.7709 13.6405 12.5801 13.4999 12.4395L10.0604 8.99999L13.4999 5.56049C13.6405 5.41984 13.7195 5.22911 13.7195 5.03024C13.7195 4.83136 13.6405 4.64063 13.4999 4.49999Z"
										fill="#A479E9"
									/>
								</svg>
							)}
						</button>
					))}
				</div>
				<div className={styles.searchBox}>
					<input
						type="text"
						value={search}
						onChange={handleInputChange}
						onKeyDown={handleKeyDown}
						placeholder="請輸入圖表關鍵字"
					/>
					<img src={getImagePath("/chart-data/search.png")} alt="search" />
				</div>
			</div>
		</div>
	);
};

export default ChartDataSearchBox;
